import { render, staticRenderFns } from "./DiscardChangesConfirmation.vue?vue&type=template&id=68e1fefa"
import script from "./DiscardChangesConfirmation.vue?vue&type=script&lang=js"
export * from "./DiscardChangesConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports